import type { AlpineComponent } from 'alpinejs'
import Masonry from 'masonry-layout'
export function MasonryLayout(): AlpineComponent<{
  init(): void
  discard(): void
}> {
  let masonry: Masonry | null = null

  return {
    init() {
      masonry = new Masonry(this.$refs.masonry, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        resize: true,
        gutter: 20,
      })
    },

    discard() {
      if (masonry && typeof masonry.destroy === 'function') {
        masonry.destroy()
      }
    },
  }
}
